module.exports = __webpack_public_path__ + "img/404-picto.5dee6109.svg";